import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTLFModule } from 'src/app/common/common.module';
import { DynamicFormQuestionComponent } from './components/dynamic-form-question/dynamic-form-question.component';
import { DynamicFormComponent } from './dynamic-form.component';


@NgModule({
  declarations: [
    DynamicFormComponent,
    DynamicFormQuestionComponent
  ],
  imports: [
    CommonModule,
    CommonTLFModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    DynamicFormComponent,
    DynamicFormQuestionComponent
  ],
})
export class DynamicFormModule { }
